<template>
    <form v-on:submit.prevent="validateBeforeSubmit">
        <div class="form-group">
            <ejs-autocomplete :highlight='1' :ignoreAccent='1' :dataSource='dataSourceProcess' :fields='fieldsSourceProcess' :select="selectSourceProcess" :showPopupButton='true' cssClass="e-outline" :placeholder="$t('textRadar.textFormSelectProcess')" suggestionCount="10000"></ejs-autocomplete>
        </div>
        <div class="form-group">
            <ejs-autocomplete :highlight='1' :ignoreAccent='1' :dataSource='dataSourceAffair' :fields='fieldsSourceAffair' :select="selectSourceAffair" :showPopupButton='true' cssClass="e-outline" :placeholder="$t('textRadar.textFormSelectSubject')" suggestionCount="10000"></ejs-autocomplete>
        </div>
        <div class="form-group">
            <ejs-textbox v-model="data.description" :multiline="true" floatLabelType="Auto" cssClass="e-outline" rows="5" :placeholder="$t('textRadar.textFormDescription')"></ejs-textbox>
        </div>
        <div class="form-group">
            <ejs-uploader ref="uploadObj" name="uploadFiles" :multiple='false' :asyncSettings="uploaderSettings" :uploading="addHeaders" :removing="addHeaders" :success="beforeUploadFiles"></ejs-uploader>
        </div>
        <ejs-progressbutton type='submit' cssClass="e-primary" ref="progressBtn" :disabled="disabledButton" :spinSettings="spinSettings" :progress="progress" :duration="50000" >{{ $t('textBtn.btnSend') }}</ejs-progressbutton>
    </form>
</template>
<script>
import axios from 'axios'
import { ProgressButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";
import { enableRipple } from '@syncfusion/ej2-base';

enableRipple(true);
Vue.use(ProgressButtonPlugin);

export default {
    name: "radar-index",
    data() {
        return {
            data: {
                process: '',
                affair: '',
                description: '',
                pathFile: false,
            },
            dataSourceProcess: [],
            fieldsSourceProcess: {value: "nombre"},
            dataSourceAffair: [],
            fieldsSourceAffair: {value: 'asunto'},
            uploaderSettings: {
                saveUrl: process.env.BASE_URL_FILE_SAVE,
                removeUrl: process.env.BASE_URL_FILE_REMOVE
            },
            spinSettings: { position: 'Right', width: 20 },
            sendEmail: false,
            disabledButton :false
        }
    },
    methods: {
        addHeaders: function(args) {
            args.currentRequest.setRequestHeader('Authorization', `Bearer ${this.$store.state.moduleSession.token}`);
        },
        beforeUploadFiles: function(args) {
            var obj = JSON.parse(args.e.srcElement.response);
            this.data.pathFile = obj.path;
        },
        getSourceProcess: function() {
            var responseData = [];
            axios.post('/auth/radar/getProcess').then(response => {
                this.dataSourceProcess = response.data;
            });
            return responseData;
        },
        selectSourceProcess: function(args) {
            if (args.itemData.id != '') {
                this.data.process = args.itemData.id;
                this.data.affair = '';
                this.dataSourceAffair = [];
                axios.post('/auth/radar/getAffairProcess', {
                    processId: args.itemData.id,
                }).then(response => {
                    this.dataSourceAffair = response.data;
                });
            }
        },
        selectSourceAffair: function(args) {
            if (args.itemData.id != '') {
                this.data.affair = args.itemData.id;
            }
        },

        validateBeforeSubmit: function() {
            this.disabledButton = true;
            this.sendEmail = false;
            this.$refs.progressBtn.enable;

            axios.post('/auth/radar/putNewRadar', this.data).then(response => {
               Vue.prototype.$eventHub.$emit('closeSidebarClick');
               this.sendEmail = true;
               Vue.prototype.$eventHub.$emit('showToastNotification', response.data);
            }).catch(error => {
                this.disabledButton = false;
                this.$refs.progressBtn.$el.classList.remove('e-progress-active');
                this.$refs.progressBtn.stop();
                console.log(error);
            });
        },
        progress: function() {
            if(this.sendEmail){
                this.$refs.progressBtn.stop();       
            }
        }
    },
    created() {
        this.getSourceProcess();
    }
}
</script>